import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const serviceFeesTiersQuery = gql`
  query ServiceFeesTiers {
    serviceFeesTiers {
      uuid
      baseServiceFee
      endValue
      startValue
      tierServiceFee
      baseServiceFeeRate
      tierServiceFeeRate
    }
  }
`

export const serviceFeesTiersKey = getQueryNames(serviceFeesTiersQuery)[0]

export default serviceFeesTiersQuery
